import { ICallBackObject, CallBackObject,ICallbackResult } from "../AjaxCallerTsImplementation/CallBackObject"
import { OperationStatus } from "../AjaxCallerTsImplementation/AjaxOperationEnums"


export interface IAjaxCallerTs {
    execute(method: string, params: any): ICallbackResult;
}

export class AjaxCallerTs implements IAjaxCallerTs {

    constructor(private url: string,
        private testMode: boolean
    ) {

    }

    execute(method: string, params: any): ICallbackResult {
        var cb = new CallBackObject(this.testMode);
        let self = this;
        let token = $('[name=__RequestVerificationToken]').val();
        let data = params;
        if (data === undefined || data === null)
            data = [];
        data["__RequestVerificationToken"] = token;
        $.ajax({
            cache: false,
            type: "POST",
            url: this.url + "/" + method,
            dataType: "JSON",
            headers: { __RequestVerificationToken: token },
            data: data,
            success: function (d, t, jq) {
                self.HandleSuccess(d, t, jq,cb);
            },
            error: function (xhr, ajaxOptions, thrownError) {
                self.HandleError(xhr, ajaxOptions, thrownError, cb);
            }
        });
        return cb;
    }

    HandleSuccess(data: any, textStatus: string, jqXHR: JQueryXHR, cb: CallBackObject): any {
        cb.NotifySuccess(data);
        cb.NotifyFinished();
    }

    HandleError(jqXHR: JQueryXHR, textStatus: string, errorThrown: string, cb: CallBackObject) {
        if (jqXHR.status == OperationStatus.NOTFOUND) {
            this.HandleStatusError(jqXHR, textStatus, errorThrown, cb)
        }
        else {
            this.HandleOperationError(jqXHR, textStatus, errorThrown, cb);
        }
        cb.NotifyFinished();
    }

    HandleStatusError(jqXHR: JQueryXHR, textStatus: string, errorThrown: string, cb: CallBackObject) {
        cb.NotifyNotFound();
    }

    HandleOperationError(jqXHR: JQueryXHR, textStatus: string, errorThrown: string, cb: CallBackObject) {
        var error = null;
        try {
            error = JSON.parse(jqXHR.responseText);
        }
        catch (err) {
            console.error(error.Message);
        }
        if (error != null) {
            var errors = null;
            try {
                // Message might contain plain string, e.g. about unauthorized access reported by the system. In that case
                // JSON parsing throws an error, so let's prepare for that.
                errors = JSON.parse(error.Message);
            } catch (err) {
                console.error(error.Message);
            }

            if (errors != null) {
                if (errors.ApiExceptionType == 1) {
                    console.error("Validation failed, errors:");
                    $.each(errors.ValidationResult.Errors, function (index, item) {
                        console.error("[" + item.Identifier + "][" + item.LocalizedMessage + "]");
                    });
                    cb.NotifyValidationFailure(errors.ValidationResult.Errors);
                } else if (errors.ApiExceptionType == 2) {
                    cb.NotifyFailure(errors.Message);
                } else {
                    console.error("Something went wrong!");
                    cb.NotifySystemError(errors.Message);
                }
            }
        }
        else {
            console.error("Something went wrong!");
            cb.NotifySystemError(errorThrown);
        }
    }

}
